// removed by extract-text-webpack-plugin
module.exports = {"mainCon":"_2L8tTAmY8A7n7sHeCr8W6j","textCon":"_1zq7bmZLCgsvkwW3Qj52kj","xButton":"_1BD1XD6v2F71ICWTu7a7z4"};


//////////////////
// WEBPACK FOOTER
// ./elements/Banner.scss
// module id = 1177
// module chunks = 0